export default __webpack_public_path__ + "static/invite-8501458accccc042cf2c215de225f39f.png";